import load from 'load-script';
import { defineNuxtPlugin } from '#imports';
import { logger } from 'data-layer/exports';

declare global {
  interface Window {
    onYouTubeIframeAPIReady?: () => void;
    YT?: typeof YT;
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const iframeAPIReady = new Promise<typeof YT>((resolve, reject) => {
    if (window.YT && window.YT.Player) {
      resolve(window.YT);
      return;
    }
    const protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
    load(`${protocol}//www.youtube.com/iframe_api`, (error) => {
      if (error) {
        logger.error('YouTube API failed to load:', error);
        reject(error);
        return;
      }
    });
    window.onYouTubeIframeAPIReady = () => {
      if (window.YT) {
        resolve(window.YT);
      } else {
        reject(new Error('YouTube API did not load correctly.'));
      }
    };
  });

  // ✅ Provide `youtubeApi` globally using `nuxtApp.provide`
  nuxtApp.provide('youtubeApi', () => iframeAPIReady);
});
